var is_mobile = window.innerWidth < 768;
var hero_splide;

document.addEventListener("DOMContentLoaded", function(event) {

  // Look for verb hero config defined by theme, otherwise just use default configs
  var splide_config = typeof vwh_config != 'undefined' ? vwh_config : {};
  hero_splide = new Splide('.hero-splide', splide_config);

  if ( is_mobile ) {

    // Loop through all items, determine if they're a video item, then show fallback image based on
    // if device browser is mobile or not.
    // We'll want to run this before the slick init
    if ( $('#hero .splide__list .item').length  ) {
      $('#hero .splide__list .item.item-video').each(function() {
        preloaderReveal($(this).find('video'));
        // $(this).css('background-image', "url('"+$(this).data('image-src')+"')");
      });
    }

  }
  else {

    /**
     * Set preload attribute to "auto" on video to allow it to start buffering.
     * The <video> template defaults to preload="none" so that it doesn't buffer
     * on mobile devices
     *
     * @since 1.1.3
     */
    $('#hero video').attr('preload', 'auto');

    /**
     * Glide before run event
     *
     * - Pauses all videos before the transition
     */
    hero_splide.on('move', function(move) {

      // pause all videos
      $('#hero video').each(function() {
        $(this)[0].pause();
      });

    });

    /**
     * Glide after run event
     *
     * - Plays the video of current slide
     */
    hero_splide.on('moved', function(move) {
      if ( $('#hero .splide__list > li:not(.splide__slide--clone)').eq(hero_splide.index).find('video').length ) {
        $('#hero .splide__list > li:not(.splide__slide--clone)').eq(hero_splide.index).find('video')[0].play();
      }
    });

  }

  hero_splide.mount();

  // Play first video, if there is one
  heroVideoInit(hero_splide);

  /**
   * VH unit fix
   *
   * @since 2.1.0
   * @link https://gitlab.verbinteractive.com/verb/Wordpress/verb-hero/-/issues/8
   */
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  var vh = window.innerHeight * 0.01;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty('--herovh', vh+'px');
  window.addEventListener('resize', function() {
    // We execute the same script as before
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--herovh', vh+'px');
  });


});


/**
 * Reveals the video/image behind the preloader
 *
 * @param {obj} video
 * @return {void}
 */
function preloaderReveal(video) {

  // This duration should also match the duration that is in css. Other wise there will be a timing mismatch
  var animation_duration = 300;

  $(video).closest('.item').find('.preloader').addClass('preloader-out');
  $(video).closest('.item').addClass('video-ready');

  setTimeout(function() {
    $(video).next('.preloader').remove();
    if ( is_mobile ) {
      $(video).remove();
    }
  }, animation_duration);

}

/**
 * Plays the first video in the hero
 *
 * @since 2.1.0
 * @param {object} hero_splide
 * @return {void}
 */
function heroVideoInit(hero_splide) {

  if ( is_mobile ) {

    // Loop through all items, determine if they're a video item, then show fallback image based on
    // if device browser is mobile or not.
    // We'll want to run this before the slick init
    if ( $('#hero .splide__list .item').length ) {
      $('#hero .splide__list .item.item-video').each(function() {
        preloaderReveal($(this).find('video'));
        // $(this).css('background-image', "url('"+$(this).data('image-src')+"')");
      });
    }

  }
  else {

    /**
     * Set preload attribute to "auto" on video to allow it to start buffering.
     * The <video> template defaults to preload="none" so that it doesn't buffer
     * on mobile devices
     *
     * @since 1.1.3
     */
    $('#hero video').attr('preload', 'auto');

    $('#hero video').each(function() {

      var video = this; // <--- so "this" can be accessed in the context of the below function(s)

      $(this).css('visibility', 'visible');

      // Wait for the video to be ready, then remove the preloader
      if ( typeof this.readyState != 'undefined' ) {

        // Check video state every x seconds until it's ready to play
        var duration_counter = 0;
        var check_interval = 50;
        var max_wait = 30 * 1000;
        var video_check = setInterval(function() {

          // At readyState 4 the video is ready to play. From here we'll animate the preloader out of view
          // Only reveal if it's been at least the min_wait time
          if ( video.readyState == 4 ) {

            // Play video on first slide if there is one
            if( $('#hero .splide__list > li:not(.splide__slide--clone)').eq(hero_splide.index).find('video').length ) {
            console.log('test2')
              $('#hero .splide__list > li:not(.splide__slide--clone)').eq(hero_splide.index).find('video')[0].play();
            }

            // Reveal video
            preloaderReveal(video);

            // Clear the interval since the video is now ready
            clearInterval(video_check);

          }

          // Has the video been loading longer than the alloted max wait? If so, show fallback image
          // Only reveal if it's been at least the min_wait time
          if ( duration_counter > max_wait ) {

            var fallback_img_src = $(video).closest('.item').data('image-src');
            $(video).closest('.item').css('background-image', "url('"+fallback_img_src+"')");

            // Reveal fallback image
            preloaderReveal(video);

            // Remove video as it could not be played
            $(video).remove();

            // Clear the interval since the video wasn't able to load
            clearInterval(video_check);

          }
          else {
            duration_counter += check_interval;
          }

        }, check_interval);

      }

      // If video auto slide is enabled, move to next slider after it's done playing
      if ( $('#hero').data('video-autoslide') && $('#hero .splide__slide').length > 1 ) {
        video.addEventListener('ended', function () {
          hero_splide.go('>');
        })
      }

    });

  }

}